export const Page = {
  home: "home",
  projectHome: "project_home",
  workspaceHome: "dashboard_home",
  insightPagesHome: "insight_pages_home",
  insightPagesList: "insight_pages_list",
  insightPagesPage: "insight_pages_page",
  insightPagesGlobalPage: "insight_pages_global_page",
  insightPagesEditor: "insight_pages_editor",
  insightPagesGlobalEditor: "insight_pages_global_editor",
  insightPagesWizardEditor: "insight_pages_wizard_editor",
  sharedInsightPage: "shared_insight_page",
  discovery: "discovery",
  listening: "listening",
  listeningQueriesOverview: "listening_queries_overview",
  listeningAnalytics: "listening_analytics",
  listeningInfluencers: "listening_analytics_influencers",
  listeningLiveMonitoring: "listening_monitoring",
  listeningClusters: "listening_clusters",
  listeningYoutubeAnalytics: "listening_youtube_analytics",
  listeningYoutubeInfluencers: "listening_youtube_influencers",
  listeningContentLandscape: "listening_content_landscape",
  socialPerformanceOwnedOverview: "social_performance_owned_overview",
  socialPerformanceOwnedDetails: "social_performance_owned_details",
  socialPerformanceOwnedPosts: "social_performance_owned_posts",
  socialPerformanceOwnedFollowersMap: "social_performance_owned_followers_map",
  socialPerformanceBenchmarkOverview: "social_performance_benchmark_overview",
  socialPerformanceBenchmarkDetails: "social_performance_benchmark_details",
  socialPerformanceBenchmarkDuel: "social_performance_benchmark_duel",
  settingsHome: "settings_home",
  settingsWorkspace: "settings_dashboard",
  noProject: "no_project",
  imageClustering: "image_clustering",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Page = typeof Page[keyof typeof Page];
